import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { XIcon, MenuIcon } from 'lucide-react';
const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <header className="absolute top-0 left-0 right-0 z-50 w-full px-4 py-6 bg-transparent" data-id="element-103">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-104">
        <Link to="/" className="flex items-center transform transition-transform hover:-translate-y-1" data-id="element-105">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oe4oUgDYZPX1RVXuLZNFcT/Chiro_Venture_-_white_no_background.png" alt="ChiroVenture Logo" className="h-10 sm:h-12" data-id="element-106" />
        </Link>
        <nav className="hidden md:flex items-center justify-center" data-id="element-107">
          <Link to="/" className="text-white hover:text-[#4ECDC4] transition-all transform hover:-translate-y-1 px-5 font-light tracking-normal" data-id="element-108">
            Home
          </Link>
          <Link to="/about" className="text-white hover:text-[#4ECDC4] transition-all transform hover:-translate-y-1 px-5 font-light tracking-normal" data-id="element-109">
            About Us
          </Link>
          <Link to="/strategy" className="text-white hover:text-[#4ECDC4] transition-all transform hover:-translate-y-1 px-5 font-light tracking-normal" data-id="element-110">
            Our Strategy
          </Link>
          <Link to="/team" className="text-white hover:text-[#4ECDC4] transition-all transform hover:-translate-y-1 px-5 font-light tracking-normal" data-id="element-111">
            Our Team
          </Link>
          <Link to="/contact" className="text-white hover:text-[#4ECDC4] transition-all transform hover:-translate-y-1 px-5 font-light tracking-normal" data-id="element-112">
            Contact Us
          </Link>
        </nav>
        <button className="md:hidden relative z-50 p-2 text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-113">
          {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-114" /> : <MenuIcon className="h-6 w-6" data-id="element-115" />}
        </button>
      </div>
      <div className={`fixed inset-0 bg-black/80 z-40 md:hidden transition-opacity duration-300 ${isMobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-116" />
      <div className={`fixed top-0 right-0 w-[280px] h-full bg-gray-900/95 backdrop-blur-sm z-40 transform transition-transform duration-300 ease-in-out md:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-117">
        <div className="flex flex-col p-6 pt-20" data-id="element-118">
          <nav className="flex flex-col space-y-4" data-id="element-119">
            <Link to="/" className="text-gray-300 hover:text-[#4ECDC4] hover:bg-gray-800/50 transition-colors px-4 py-3 rounded-lg font-light tracking-normal" onClick={() => setIsMobileMenuOpen(false)} data-id="element-120">
              Home
            </Link>
            <Link to="/about" className="text-gray-300 hover:text-[#4ECDC4] hover:bg-gray-800/50 transition-colors px-4 py-3 rounded-lg font-light tracking-normal" onClick={() => setIsMobileMenuOpen(false)} data-id="element-121">
              About Us
            </Link>
            <Link to="/strategy" className="text-gray-300 hover:text-[#4ECDC4] hover:bg-gray-800/50 transition-colors px-4 py-3 rounded-lg font-light tracking-normal" onClick={() => setIsMobileMenuOpen(false)} data-id="element-122">
              Our Strategy
            </Link>
            <Link to="/team" className="text-gray-300 hover:text-[#4ECDC4] hover:bg-gray-800/50 transition-colors px-4 py-3 rounded-lg font-light tracking-normal" onClick={() => setIsMobileMenuOpen(false)} data-id="element-123">
              Our Team
            </Link>
            <Link to="/contact" className="text-gray-300 hover:text-[#4ECDC4] hover:bg-gray-800/50 transition-colors px-4 py-3 rounded-lg font-light tracking-normal" onClick={() => setIsMobileMenuOpen(false)} data-id="element-124">
              Contact Us
            </Link>
          </nav>
        </div>
      </div>
    </header>;
};
export default Navigation;